/* eslint-disable */
import _ from 'lodash';
import config from './config';
import DDLogs from '@/DDLogs';

let incognito = false;

const Segment = {
  install(Vue, options) {
    !(function () {
      const analytics = window.analytics = window.analytics || [];
      if (!analytics.initialize) {
        if (analytics.invoked) { window.console && console.error && console.error('Segment snippet included twice.'); } else {
          analytics.invoked = !0;
          analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'];
          analytics.factory = function (t) {
            return function () {
              const e = Array.prototype.slice.call(arguments);
              e.unshift(t);
              analytics.push(e);
              return analytics;
            };
          };
          for (let t = 0; t < analytics.methods.length; t++) {
            const e = analytics.methods[t];
            analytics[e] = analytics.factory(e);
          }
          analytics.load = function (t, e) {
            const n = document.createElement('script');
            n.type = 'text/javascript';
            n.async = !0;
            n.src = `https://cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
            const a = document.getElementsByTagName('script')[0];
            a.parentNode.insertBefore(n, a);
            analytics._loadOptions = e;
          };
          analytics.SNIPPET_VERSION = '4.1.0';
          analytics.load(config.get().segmentSourceId);
          analytics.page();
        }
      }
    }());
  },

  setIncognito(isIncognito) {
    incognito = isIncognito;
  },

  identify(riseupAccountId, data) {
    analytics.identify(
      riseupAccountId,
      _.assign({ incognito }, data),
      {
        integrations: {
          'Facebook Pixel': false
        }
      });
    DDLogs.addGlobalContext('customerId', riseupAccountId);
    DDLogs.addGlobalContext('riseupAccountId', riseupAccountId);
    DDLogs.log('identify', _.assign({}, { riseupAccountId }, data));
  },

  trackUserInteraction(eventName, data) {
    analytics.track(eventName, _.assign({ incognito }, data,
      {
        integrations: {
          'Facebook Pixel': false
        }
      }));
    DDLogs.log(eventName, data);
  },
};

export default Segment;
